import { render, staticRenderFns } from "./stores-list-page.vue?vue&type=template&id=a02d7ba0&scoped=true&"
import script from "./stores-list-page.vue?vue&type=script&lang=js&"
export * from "./stores-list-page.vue?vue&type=script&lang=js&"
import style0 from "./stores-list-page.vue?vue&type=style&index=0&id=a02d7ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02d7ba0",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl})
